import styles from './styles/ClearAllButton.module.scss';
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Ssvg } from '../../../Components/react/Ssvg';
import { useAlgoliaAppContext } from '../../hooks/useAlgoliaAppContext';
import { useNumberOfActiveFilters } from '../../hooks/useNumberOfActiveFilters';
import { queryLetter } from '../../configs';
import { SEARCH_PARAM_KEY_SORT, SEARCH_PARAM_KEY_TYPE } from '../../constants/searchParamKeys';
import { FACET_KEY_TAGS } from '../../constants/facetKeys';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
export const ClearAllButton = () => {
    const [nbActiveFilters] = useNumberOfActiveFilters();
    const [searchParams] = useSearchParams();
    const { handle } = useParams();
    const { pagePath } = useAlgoliaAppContext();
    const navigate = useNavigate();
    if (nbActiveFilters < 1)
        return null;
    const sp = new URLSearchParams();
    const query = searchParams.get(queryLetter);
    query !== null && sp.set(queryLetter, query);
    const sort = searchParams.get(SEARCH_PARAM_KEY_SORT);
    sort !== null && sp.set(SEARCH_PARAM_KEY_SORT, sort);
    const tags = searchParams.get(FACET_KEY_TAGS);
    tags !== null && sp.set(FACET_KEY_TAGS, tags);
    if (!MEDIA_BREAKPOINTS.MD_UP.matches) {
        const type = searchParams.get(SEARCH_PARAM_KEY_TYPE);
        type !== null && sp.set(SEARCH_PARAM_KEY_TYPE, type);
    }
    sp.sort();
    const spStr = sp.toString();
    return (React.createElement("div", { className: `pos:r z:4 text:right ${styles.buttonWrapper}` },
        React.createElement("button", { className: `btn:cleared fw:700 ${styles.button}`, onClick: () => {
                navigate({
                    pathname: `/${pagePath}/${handle ?? ''}`,
                    search: spStr.length > 0 ? `?${spStr}` : undefined
                });
            } },
            React.createElement(Ssvg, { icon: "#icon--clear-x", className: styles.icon }),
            " CLEAR ALL")));
};
